import { DateTime } from "luxon";
import { FunctionCloneDeep, FunctionZeroPad } from "radium-omnibus";
import {
  FunctionCreateDay,
  FunctionCreateHour,
  FunctionCreateMonth,
  FunctionCreateYear,
  timestampNow,
  toISO,
} from "../../../utils/useFunction";
import {
  checkTime,
  CONSTANT_CALENDAR,
  inverseTime,
  startTime,
  thisHourPushthirtyMinites,
  time,
} from "../render/Busket.ModalDateTime";
import {
  ARRAY_DATE,
  ARRAY_DATE_WEEK,
  THIS_TIME_IN_N_OUT,
} from "./Busket.GenerateDate";
import { LAST_TIME_YOU_STILL_CAN_BOOK } from "../../../utils/useConstants";

const FunctionFormatDateTobeNormal = (date) => {
  // 1.4.2023 to 2023-01-01
  const splitDate = date.split(".");
  const year = splitDate[2];
  const month = FunctionZeroPad(splitDate[0], 2);
  const day = FunctionZeroPad(splitDate[1], 2);
  return `${year}-${month}-${day}`;
};

// startTime;

export const FunctionFindNearestToDate = (
  calendars,
  selectedDate,
  thisTimeSelected
) => {
  if (!selectedDate) return;
  let prepairDate = {}; // ตัวแปรเก็บ วันที่ ที่จะใช้
  const newToday = new Date(toISO(selectedDate)).getDate();

  const findFromDate = calendars.filter((row) => {
    const thisDay = String(row?.day?.split("-")[2])?.slice(0, 2) || 0;
    return row.status === false && Number(thisDay) >= newToday; // หาวันที่ใกล่ที่สุดที่ยังเปิดอยู่
  });

  const findToDate = calendars.filter((row) => {
    const thisDay = String(row?.day?.split("-")[2])?.slice(0, 2) || 0;

    return (
      row.status === false &&
      Number(thisDay) > newToday &&
      row?._id !== findFromDate[0]?._id
    );
  }); // หาวันที่ใกล่ที่สุดที่ไม่ซ้ำกับข้างบน และยังเปิดอยู่

  const nearestFromDate = findFromDate[0]; //เอาวันที่ใกล่ที่สุดที่ยังเปิดอยู่
  const nearestToDate = findToDate[0]; //เอาวันที่ใกล่ที่สุดที่ยังเปิดอยู่ และไม่ซ้ำกับข้างบน

  // console.log("CHECKER AFTER CLICK : ", {
  //   prepairDate,
  //   newToday,
  //   findFromDate,
  //   findToDate,
  //   nearestFromDate,
  //   nearestToDate,
  //   thisTimeSelected,
  // });

  if (nearestToDate) {
    //วันที่ส่ง
    const onlyDate = nearestToDate.day.slice(0, 10); //ตัวชัวโมงออกไม่งั้นวันจะเพี้ยน

    // const moreThanTwentFourHour =
    //   new Date(onlyDate).getTime() -
    //   new Date(FunctionFormatDateTobeNormal(selectedDate)).getTime() >
    // 86400000;

    const moreThanTwentFourHour =
      DateTime.fromISO(nearestToDate.day).toMillis() -
        new Date(FunctionFormatDateTobeNormal(selectedDate)).getTime() >
      86400000;

    // console.log("moreThanTwentFourHour", {
    //   moreThanTwentFourHour,
    //   onlyDate,
    //   selectedDate_f: FunctionFormatDateTobeNormal(selectedDate),
    //   selectedDate,
    // });

    // const nearestFromDatePlusOneOld = new Date( // ต้อง + 1 เราจะไม่ + หลัง ไม่งั้นพอเอามาเทียบโดนการลบ เวลาจะเพี้ยน
    //   nearestFromDate?.day?.slice(0, 10)
    // ).setDate(new Date(nearestFromDate?.day?.slice(0, 10)).getDate() + 1);

    const nearestFromDatePlusOne = DateTime.fromISO(
      nearestFromDate?.day?.slice(0, 10)
    )
      .plus({
        days: 1,
      })
      .get("day");

    // console.log("nearestFromDatePlusOne", {
    //   nearestFromDatePlusOne,
    //   nearestFromDatePlusOneOld,
    // });

    // const   = nearestFromDatePlusOne === new Date(onlyDate).getDate(); //only date === "2023-02-05"

    const isNextDay =
      nearestFromDatePlusOne ===
      Number(nearestToDate?.showDate?.split(".")[1] || 0);

    // console.log("moreThanTwentFourHour", { moreThanTwentFourHour, isNextDay });
    // console.log("isNextDay", {
    //   isNextDay,
    //   nearestFromDatePlusOne,
    //   c: nearestToDate?.showDate?.split(".")[1],
    //   nearestToDate,
    // });
    if (moreThanTwentFourHour && !isNextDay) {
      // console.log("TRIGGER 1");
      // ถ้าไม่ใช่วันถัดไป สามารถเลือก slot ได้ตั้งแต่เวลา 8.00 น. ถึง 20.00 น.
      const findFreeSlot = time
        .map((row) => {
          const plan = nearestToDate[CONSTANT_CALENDAR[row][0]];
          const booked = nearestToDate[CONSTANT_CALENDAR[row][1]];
          const remaining = plan - booked;
          return { time: row, remaining };
        })
        ?.filter((row) => {
          return row.remaining > 0;
        });
      const findNearestTime = findFreeSlot[0]?.time;

      // prepairDate = {
      //   ...prepairDate,
      //   return_date: {
      //     date: `${new Date(onlyDate).getMonth() + 1}.${new Date(
      //       onlyDate
      //     ).getDate()}.${new Date(onlyDate).getFullYear()}`, //11.29.2022
      //     month: new Date(onlyDate).getMonth() + 1,
      //     name: ARRAY_DATE[new Date(onlyDate).getDay()],
      //     disabled: false,
      //     filter: false,
      //     day: new Date(onlyDate).getDate(),
      //     year: new Date(onlyDate).getFullYear(),
      //     time: new Date(onlyDate).getTime(),
      //   },
      //   return_time: findNearestTime,
      // };

      const stringDate = onlyDate.split("-");
      prepairDate = {
        ...prepairDate,
        return_date: {
          date: `${Number(stringDate[1])}.${Number(stringDate[2])}.${Number(
            stringDate[0]
          )}`,

          month: Number(stringDate[1]),
          name: ARRAY_DATE_WEEK[
            DateTime.fromISO(onlyDate)
              .setLocale("th")
              .setZone("UTC+7")
              .get("weekday")
          ],
          disabled: false,
          filter: false,
          day: Number(stringDate[2]),
          year: Number(stringDate[0]),
          time: DateTime.fromISO(onlyDate).toMillis(),
        },
        return_time: findNearestTime,
      };
    } else if (isNextDay) {
      // console.log("TRIGGER 2");
      // ถ้าเป็นวันถัดไป สามารถเลือก slot ได้หลังจากเวลา รับ แล้วเท่านั้น 24 ชั่วโมง (slot เดียวกันกับเวลารับ)
      const findFreeSlot = time
        ?.map((row) => {
          const plan = nearestToDate[CONSTANT_CALENDAR[row][0]];
          const booked = nearestToDate[CONSTANT_CALENDAR[row][1]];
          const remaining = plan - booked;
          return { time: row, remaining, last: checkTime[row] };
        })
        ?.filter((row) => {
          // console.log("CHECK POINT3", {
          //   row,
          //   nearestFromDate,
          //   start: startTime[thisTimeSelected],
          //   pick_up_time: thisTimeSelected,
          //   end: row.last,
          // });
          return row.remaining > 0 && startTime[thisTimeSelected] < row.last;
        });

      // console.log("findFreeSlot", { findFreeSlot, time, onlyDate });

      const findNearestTime = findFreeSlot[0]?.time;

      // const prepairDate_old = {
      //   ...prepairDate,
      //   return_date: {
      //     date: `${new Date(onlyDate).getMonth() + 1}.${new Date(
      //       onlyDate
      //     ).getDate()}.${new Date(onlyDate).getFullYear()}`, //11.29.2022
      //     month: new Date(onlyDate).getMonth() + 1,
      //     name: ARRAY_DATE[new Date(onlyDate).getDay()],
      //     disabled: false,
      //     filter: false,
      //     day: new Date(onlyDate).getDate(),
      //     year: new Date(onlyDate).getFullYear(),
      //     time: new Date(onlyDate).getTime(),
      //   },
      //   return_time: findNearestTime,
      // };

      const stringDate = onlyDate.split("-");
      prepairDate = {
        ...prepairDate,
        return_date: {
          date: `${Number(stringDate[1])}.${Number(stringDate[2])}.${Number(
            stringDate[0]
          )}`,

          month: Number(stringDate[1]),
          name: ARRAY_DATE[
            DateTime.fromISO(onlyDate)
              .setLocale("th")
              .setZone("UTC+7")
              .get("weekday")
          ],
          disabled: false,
          filter: false,
          day: Number(stringDate[2]),
          year: Number(stringDate[0]),
          time: DateTime.fromISO(onlyDate).toMillis(),
        },
        return_time: findNearestTime,
      };

      // console.log("prepairDate", {
      //   prepairDate,
      //   prepairDate_old,
      //   name: ARRAY_DATE[DateTime.fromISO(onlyDate).get("weekday") - 1],
      //   checkdate: DateTime.fromISO(onlyDate),
      //   thiss: DateTime.fromISO(onlyDate).get("weekday"),
      //   oldn: new Date(onlyDate).getDay(),
      // });
    }
  }

  return prepairDate;
};

export const BasketAutoSelectDateValue = ({ calendars, address }) => {
  if (address?.link && calendars?.length > 0) {
    // ถ้าไม่ได้เลือกมาก่อน ให้ auto // ต้อง มี สถานที่ก่อน ถึงไป query calendars  ได้ จะมี BANGKOK กับ PATTAYA
    let prepairDate = {}; // ตัวแปรเก็บ วันที่ ที่จะใช้

    const newToday = FunctionCreateDay();
    const thisHour = FunctionCreateHour();

    const findFromDate = calendars.filter((row) => {
      const thisDay = String(row?.day?.split("-")[2])?.slice(0, 2) || 0;
      // const thisTimeAvailable = true; // ตรวจสอบว่าเวลานี้ ยังเปิดอยู่หรือไม่

      const thiSlotStillLeft =
        row?.season_mix_planned - row?.season_mix_booked > 0;

      //if morethan 19.00 show be next day
      const thisTimeAvailable =
        thisDay === newToday ? thisHour < LAST_TIME_YOU_STILL_CAN_BOOK : true;

      // console.log("CHECK POINT 1", {
      //   thisDay,
      //   newToday,
      //   thisHour,
      //   thiSlotStillLeft,
      //   thisTimeAvailable,
      // });

      return (
        row.status === false &&
        Number(thisDay) >= newToday &&
        thisTimeAvailable &&
        thiSlotStillLeft
      ); // หาวันที่ใกล่ที่สุดที่ยังเปิดอยู่
    });

    const findToDate = calendars.filter((row) => {
      const thisDay = String(row?.day?.split("-")[2])?.slice(0, 2) || 0;

      const thiSlotStillLeft =
        row?.season_mix_planned - row?.season_mix_booked > 0;

      return (
        row.status === false &&
        Number(thisDay) > newToday &&
        row?._id !== findFromDate[0]?._id &&
        thiSlotStillLeft
      );
    }); // หาวันที่ใกล่ที่สุดที่ไม่ซ้ำกับข้างบน และยังเปิดอยู่

    const nearestFromDate = findFromDate[0]; //เอาวันที่ใกล่ที่สุดที่ยังเปิดอยู่
    const nearestToDate = findToDate[0]; //เอาวันที่ใกล่ที่สุดที่ยังเปิดอยู่ และไม่ซ้ำกับข้างบน

    // console.log("nearestFromDate", { nearestFromDate, nearestToDate });

    if (nearestFromDate && nearestToDate) {
      const onlyDateFromDate = DateTime.fromISO(
        nearestFromDate?.day?.slice(0, 10)
      )
        .setLocale("th")
        .setZone("UTC+7")
        .toISO(); // วันที่เป็น 2021-11-29
      const onlyToDate = DateTime.fromISO(nearestToDate?.day?.slice(0, 10))
        .setLocale("th")
        .setZone("UTC+7")
        .toISO(); // วันที่เป็น 2021-11-29
      return {
        pick_up_date: {
          date: `${new Date(onlyDateFromDate).getMonth() + 1}.${new Date(
            onlyDateFromDate
          ).getDate()}.${new Date(onlyDateFromDate).getFullYear()}`, //11.29.2022
          month: new Date(onlyDateFromDate).getMonth() + 1,
          name: ARRAY_DATE[new Date(onlyDateFromDate).getDay()],
          disabled: false,
          filter: false,
          day: new Date(onlyDateFromDate).getDate(),
          year: new Date(onlyDateFromDate).getFullYear(),
          time: new Date(onlyDateFromDate).getTime(),
        },
        return_date: {
          date: `${new Date(onlyToDate).getMonth() + 1}.${new Date(
            onlyToDate
          ).getDate()}.${new Date(onlyToDate).getFullYear()}`, //11.29.2022
          month: new Date(onlyToDate).getMonth() + 1,
          name: ARRAY_DATE[new Date(onlyToDate).getDay()],
          disabled: false,
          filter: false,
          day: new Date(onlyToDate).getDate(),
          year: new Date(onlyToDate).getFullYear(),
          time: new Date(onlyToDate).getTime(),
        },
        return_time: THIS_TIME_IN_N_OUT,
        pick_up_time: THIS_TIME_IN_N_OUT,
      };
    } else if (nearestFromDate) {
      const onlyDateFromDate = DateTime.fromISO(
        nearestFromDate?.day?.slice(0, 10)
      )
        .setLocale("th")
        .setZone("UTC+7")
        .toISO(); // วันที่เป็น 2021-11-29

      return {
        pick_up_date: {
          date: `${new Date(onlyDateFromDate).getMonth() + 1}.${new Date(
            onlyDateFromDate
          ).getDate()}.${new Date(onlyDateFromDate).getFullYear()}`, //11.29.2022
          month: new Date(onlyDateFromDate).getMonth() + 1,
          name: ARRAY_DATE[new Date(onlyDateFromDate).getDay()],
          disabled: false,
          filter: false,
          day: new Date(onlyDateFromDate).getDate(),
          year: new Date(onlyDateFromDate).getFullYear(),
          time: new Date(onlyDateFromDate).getTime(),
        },
        pick_up_time: THIS_TIME_IN_N_OUT,
      };
    }

    // if (nearestFromDate) {
    //   const moreThanTwentFourHour =
    //     new Date(nearestFromDate?.day).getTime() - new Date().getTime() >
    //     86400000; // หาว่า วันที่ใกล่ที่สุด มากกว่า 24 ชั่วโมงหรือไม่

    //   const onlyDate = DateTime.fromISO(nearestFromDate?.day?.slice(0, 10))
    //     .setLocale("th")
    //     .setZone("UTC+7")
    //     .toISO(); // วันที่เป็น 2021-11-29

    //   if (moreThanTwentFourHour) {
    //     // ถ้ามากกว่า 24 ชั่วโมง สามารถเลือก slot ไหนก็ได้ ในวันนั้นที่เปิดและใกล่ที่สุด
    //     const findFreeSlot = time
    //       .map((row) => {
    //         const plan = nearestFromDate[CONSTANT_CALENDAR[row][0]];
    //         const booked = nearestFromDate[CONSTANT_CALENDAR[row][1]];
    //         const remaining = plan - booked;
    //         return { time: row, remaining };
    //       })
    //       ?.filter((row) => {
    //         return row.remaining > 0;
    //       });
    //     const findNearestTime = findFreeSlot[0]?.time;

    //     prepairDate = {
    //       ...prepairDate,
    //       pick_up_date: {
    //         date: `${new Date(onlyDate).getMonth() + 1}.${new Date(
    //           onlyDate
    //         ).getDate()}.${new Date(onlyDate).getFullYear()}`, //11.29.2022
    //         month: new Date(onlyDate).getMonth() + 1,
    //         name: ARRAY_DATE[new Date(onlyDate).getDay()],
    //         disabled: false,
    //         filter: false,
    //         day: new Date(onlyDate).getDate(),
    //         year: new Date(onlyDate).getFullYear(),
    //         time: new Date(onlyDate).getTime(),
    //       },
    //       pick_up_time: findNearestTime,
    //     };
    //     console.log("moreThanTwentFourHour", {
    //       findFreeSlot,
    //       findNearestTime,
    //       prepairDate,
    //       onlyDate,
    //     });
    //   } else {
    //     // ถ้าน้อยกว่า 24 ชั่วโมง ให้เลือก slot ที่เปิดในวันนั้นที่ใกล่ที่สุด

    //     const findFreeSlot = time
    //       .map((row) => {
    //         const plan = nearestFromDate[CONSTANT_CALENDAR[row][0]];
    //         const booked = nearestFromDate[CONSTANT_CALENDAR[row][1]];
    //         const remaining = plan - booked;
    //         return { time: row, remaining, last: checkTime[row] };
    //       })
    //       ?.filter((row) => {
    //         return row.remaining > 0 && row.last > thisHourPushthirtyMinites; // หาว่าในอีก 30 นาที จะเป็นเวลาไหน แล้วเลือกอันที่ใกล่สุด นอกนั้นตัดทิ้ง
    //       });

    //     const findNearestTime = findFreeSlot[0]?.time;

    //     prepairDate = {
    //       pick_up_date: {
    //         date: `${new Date(onlyDate).getMonth() + 1}.${new Date(
    //           onlyDate
    //         ).getDate()}.${new Date(onlyDate).getFullYear()}`, //11.29.2022
    //         month: new Date(onlyDate).getMonth() + 1,
    //         name: ARRAY_DATE[new Date(onlyDate).getDay()],
    //         disabled: false,
    //         filter: false,
    //         day: new Date(onlyDate).getDate(),
    //         year: new Date(onlyDate).getFullYear(),
    //         time: new Date(onlyDate).getTime(),
    //       },
    //       pick_up_time: findNearestTime,
    //     };
    //     // console.log("lessThanTwentFourHour", {
    //     //   findFreeSlot,
    //     //   findNearestTime,
    //     //   prepairDate,
    //     //   onlyDate,
    //     // });
    //   }
    // }
    // if (nearestToDate) {
    //   //วันที่ส่ง
    //   // const onlyDate = nearestToDate.day.slice(0, 10); //ตัวชัวโมงออกไม่งั้นวันจะเพี้ยน

    //   const onlyDate = DateTime.fromISO(nearestToDate?.day?.slice(0, 10))
    //     .setLocale("th")
    //     .setZone("UTC+7")
    //     .toISO(); // วันที่เป็น 2021-11-29

    //   const moreThanTwentFourHour =
    //     new Date(onlyDate).getTime() - timestampNow() > 86400000;

    //   const nearestFromDatePlusOne = new Date( // ต้อง + 1 เราจะไม่ + หลัง ไม่งั้นพอเอามาเทียบโดนการลบ เวลาจะเพี้ยน
    //     nearestFromDate?.day?.slice(0, 10)
    //   ).setDate(new Date(nearestFromDate?.day?.slice(0, 10)).getDate() + 1);

    //   const isNextDay =
    //     new Date(nearestFromDatePlusOne).getDate() ===
    //     new Date(onlyDate).getDate();

    //   if (moreThanTwentFourHour && !isNextDay) {
    //     // ถ้าไม่ใช่วันถัดไป สามารถเลือก slot ได้ตั้งแต่เวลา 8.00 น. ถึง 20.00 น.
    //     const findFreeSlot = time
    //       .map((row) => {
    //         const plan = nearestToDate[CONSTANT_CALENDAR[row][0]];
    //         const booked = nearestToDate[CONSTANT_CALENDAR[row][1]];
    //         const remaining = plan - booked;
    //         return { time: row, remaining };
    //       })
    //       ?.filter((row) => {
    //         return row.remaining > 0;
    //       });

    //     const findNearestTime = findFreeSlot[0]?.time;

    //     prepairDate = {
    //       ...prepairDate,
    //       return_date: {
    //         date: `${new Date(onlyDate).getMonth() + 1}.${new Date(
    //           onlyDate
    //         ).getDate()}.${new Date(onlyDate).getFullYear()}`, //11.29.2022
    //         month: new Date(onlyDate).getMonth() + 1,
    //         name: ARRAY_DATE[new Date(onlyDate).getDay()],
    //         disabled: false,
    //         filter: false,
    //         day: new Date(onlyDate).getDate(),
    //         year: new Date(onlyDate).getFullYear(),
    //         time: new Date(onlyDate).getTime(),
    //       },
    //       return_time: findNearestTime,
    //     };
    //   } else if (isNextDay) {
    //     // ถ้าเป็นวันถัดไป สามารถเลือก slot ได้หลังจากเวลา รับ แล้วเท่านั้น 24 ชั่วโมง (slot เดียวกันกับเวลารับ)
    //     const findFreeSlot = time
    //       .map((row) => {
    //         const plan = nearestToDate[CONSTANT_CALENDAR[row][0]];
    //         const booked = nearestToDate[CONSTANT_CALENDAR[row][1]];
    //         const remaining = plan - booked;
    //         return { time: row, remaining, last: checkTime[row] };
    //       })
    //       ?.filter((row) => {
    //         return row.remaining > 0 && row.last > thisHourPushthirtyMinites;
    //       });

    //     const findNearestTime = findFreeSlot[0]?.time;

    //     prepairDate = {
    //       ...prepairDate,
    //       return_date: {
    //         date: `${new Date(onlyDate).getMonth() + 1}.${new Date(
    //           onlyDate
    //         ).getDate()}.${new Date(onlyDate).getFullYear()}`, //11.29.2022
    //         month: new Date(onlyDate).getMonth() + 1,
    //         name: ARRAY_DATE[new Date(onlyDate).getDay()],
    //         disabled: false,
    //         filter: false,
    //         day: new Date(onlyDate).getDate(),
    //         year: new Date(onlyDate).getFullYear(),
    //         time: new Date(onlyDate).getTime(),
    //       },
    //       return_time: findNearestTime,
    //     };
    //   }
    // }
    // return prepairDate;
  }
};

const BasketAutoSelectDate = ({
  dateTime,
  calendars,
  setDateTime,
  address,
}) => {
  const isCorrectFormDate = // ถ้าไม่ได้เลือกมาก่อน ให้ auto
    dateTime?.pick_up_date?.date &&
    dateTime?.return_date?.date &&
    dateTime?.return_time &&
    dateTime?.pick_up_time;

  const newToday = FunctionCreateDay();
  const thisHour = FunctionCreateHour();
  const newYear = FunctionCreateYear()

  // const currentPickUpDate = dateTime?.pick_up_date?.day;

  //อันที่เลือกอยู่ถ้าวันนี้เกิน 5 โมง เลือกใหม่
  // const SelctedtTimStilleAvailable =
  //   currentPickUpDate === newToday
  //     ? thisHour <= LAST_TIME_YOU_STILL_CAN_BOOK
  //       ? false
  //       : true
  //     : true;

  //อันทีเลือกอยู่ถ้าเหลือ 0 แล้ว ให้เลือกใหม่

  // calendars = calendars?.filter((row) => {
  //   const thisCalrendarDate = Number(row?.showDate?.split(".")[1]);
  //   console.log("thisCalrendarDate", thisCalrendarDate);
  //   return thisCalrendarDate === currentPickUpDate;
  // });

  // const thisSelectedCalrendar = calendars?.find((row) => {
  //   const thisCalrendarDate = Number(row?.showDate?.split(".")[1]);
  //   console.log("currentPickUpDate");
  //   return thisCalrendarDate === currentPickUpDate;
  // });

  // if (thisSelectedCalrendar) {
  //   if (!thisSelectedCalrendar) {
  //     calendars = calendars?.filter((row) => {
  //       const thisCalrendarDate = Number(row?.showDate?.split(".")[1]);
  //       return thisCalrendarDate !== currentPickUpDate;
  //     });
  //   }
  // }

  // let currentSelectedDateAvailable = false;

  // if (thisSelectedCalrendar) {
  //   const dateAvailable =
  //     thisSelectedCalrendar?.season_mix_planned -
  //       thisSelectedCalrendar?.season_mix_booked >
  //     0;

  //   currentSelectedDateAvailable = dateAvailable;
  // }

  const checkIn = address?.link && calendars?.length > 0 && !isCorrectFormDate;

  // console.log("IN BasketAutoSelectDate", {
  //   dateTime,
  //   SelctedtTimStilleAvailable,
  //   thisSelectedCalrendar,
  //   currentSelectedDateAvailable,
  //   thisHour,
  //   LAST_TIME_YOU_STILL_CAN_BOOK,
  //   newToday,
  //   currentPickUpDate,
  //   check: thisHour <= LAST_TIME_YOU_STILL_CAN_BOOK,
  //   checkIn,
  //   address,
  //   isCorrectFormDate,
  //   calendars,
  // });

  if (checkIn) {
    // ถ้าไม่ได้เลือกมาก่อน ให้ auto // ต้อง มี สถานที่ก่อน ถึงไป query calendars  ได้ จะมี BANGKOK กับ PATTAYA
    // let prepairDate = {}; // ตัวแปรเก็บ วันที่ ที่จะใช้

    const newMonth = FunctionCreateMonth();

    const findFromDate = calendars.filter((row) => {
      const thisDay = Number(String(row?.day?.split("-")[2])?.slice(0, 2) || 0);
      const thisMonth = Number(String(row?.day?.split("-")[1]) || 0);

      const thiSlotStillLeft =
        row?.season_mix_planned - row?.season_mix_booked > 0;
      // const thisTimeAvailable = true; // ตรวจสอบว่าเวลานี้ ยังเปิดอยู่หรือไม่

      //if morethan 17.00 show be next day
      const thisTimeAvailable =
        thisDay === newToday ? thisHour < LAST_TIME_YOU_STILL_CAN_BOOK : true;

      const isTodayOrNextDay = thisDay >= newToday || thisMonth > newMonth;
      // console.log("CHECK", {
      //   thisDay,
      //   newToday,
      //   thisTimeAvailable,
      //   thiSlotStillLeft,
      //   thisHour,
      //   row,
      //   thisMonth,
      //   newMonth,
      // });

      return (
        row.status === false &&
        isTodayOrNextDay &&
        thisTimeAvailable &&
        thiSlotStillLeft
      ); // หาวันที่ใกล่ที่สุดที่ยังเปิดอยู่
    });

    const findToDate = calendars.filter((row) => {
      const thisDay = Number(String(row?.day?.split("-")[2])?.slice(0, 2) || 0);
      const thisMonth = Number(String(row?.day?.split("-")[1]) || 0);
      const thisYear = Number(String(row?.day?.split("-")[0]) || 0);

      const isTodayOrNextDay = thisDay > newToday || thisMonth > newMonth || thisYear > newYear;

      const thiSlotStillLeft =
        row?.season_mix_planned - row?.season_mix_booked > 0;

      return (
        row.status === false &&
        isTodayOrNextDay &&
        row?._id !== findFromDate[0]?._id &&
        thiSlotStillLeft
      );
    }); // หาวันที่ใกล่ที่สุดที่ไม่ซ้ำกับข้างบน และยังเปิดอยู่

    console.log("object, calendars", calendars);
    console.log("findToDate", findToDate);

    const nearestFromDate = findFromDate[0]; //เอาวันที่ใกล่ที่สุดที่ยังเปิดอยู่
    const nearestToDate = findToDate[0]; //เอาวันที่ใกล่ที่สุดที่ยังเปิดอยู่ และไม่ซ้ำกับข้างบน

    if (nearestFromDate && nearestToDate) {
      const onlyDateFromDate = DateTime.fromISO(
        nearestFromDate?.day?.slice(0, 10)
      )
        .setLocale("th")
        .setZone("UTC+7")
        .toISO(); // วันที่เป็น 2021-11-29
      const onlyToDate = DateTime.fromISO(nearestToDate?.day?.slice(0, 10))
        .setLocale("th")
        .setZone("UTC+7")
        .toISO(); // วันที่เป็น 2021-11-29
      setDateTime((prev) => {
        let cloneDeep = FunctionCloneDeep(prev);
        cloneDeep = {
          ...cloneDeep,
          pick_up_date: {
            date: `${new Date(onlyDateFromDate).getMonth() + 1}.${new Date(
              onlyDateFromDate
            ).getDate()}.${new Date(onlyDateFromDate).getFullYear()}`, //11.29.2022
            month: new Date(onlyDateFromDate).getMonth() + 1,
            name: ARRAY_DATE[new Date(onlyDateFromDate).getDay()],
            disabled: false,
            filter: false,
            day: new Date(onlyDateFromDate).getDate(),
            year: new Date(onlyDateFromDate).getFullYear(),
            time: new Date(onlyDateFromDate).getTime(),
          },
          return_date: {
            date: `${new Date(onlyToDate).getMonth() + 1}.${new Date(
              onlyToDate
            ).getDate()}.${new Date(onlyToDate).getFullYear()}`, //11.29.2022
            month: new Date(onlyToDate).getMonth() + 1,
            name: ARRAY_DATE[new Date(onlyToDate).getDay()],
            disabled: false,
            filter: false,
            day: new Date(onlyToDate).getDate(),
            year: new Date(onlyToDate).getFullYear(),
            time: new Date(onlyToDate).getTime(),
          },
          return_time: THIS_TIME_IN_N_OUT,
          pick_up_time: THIS_TIME_IN_N_OUT,
        };
        return cloneDeep;
      });
    } else if (nearestFromDate) {
      const onlyDateFromDate = DateTime.fromISO(
        nearestFromDate?.day?.slice(0, 10)
      )
        .setLocale("th")
        .setZone("UTC+7")
        .toISO(); // วันที่เป็น 2021-11-29

      setDateTime((prev) => {
        let cloneDeep = FunctionCloneDeep(prev);
        cloneDeep = {
          ...cloneDeep,
          pick_up_date: {
            date: `${new Date(onlyDateFromDate).getMonth() + 1}.${new Date(
              onlyDateFromDate
            ).getDate()}.${new Date(onlyDateFromDate).getFullYear()}`, //11.29.2022
            month: new Date(onlyDateFromDate).getMonth() + 1,
            name: ARRAY_DATE[new Date(onlyDateFromDate).getDay()],
            disabled: false,
            filter: false,
            day: new Date(onlyDateFromDate).getDate(),
            year: new Date(onlyDateFromDate).getFullYear(),
            time: new Date(onlyDateFromDate).getTime(),
          },
          pick_up_time: THIS_TIME_IN_N_OUT,
        };

        return cloneDeep;
      });
    }

    // if (nearestFromDate) {
    //   const moreThanTwentFourHour =
    //     new Date(nearestFromDate?.day).getTime() - new Date().getTime() >
    //     86400000; // หาว่า วันที่ใกล่ที่สุด มากกว่า 24 ชั่วโมงหรือไม่

    // const onlyDate = DateTime.fromISO(nearestFromDate?.day?.slice(0, 10))
    //   .setLocale("th")
    //   .setZone("UTC+7")
    //   .toISO(); // วันที่เป็น 2021-11-29

    //   if (moreThanTwentFourHour) {
    //     // ถ้ามากกว่า 24 ชั่วโมง สามารถเลือก slot ไหนก็ได้ ในวันนั้นที่เปิดและใกล่ที่สุด
    //     const findFreeSlot = time
    //       .map((row) => {
    //         const plan = nearestFromDate[CONSTANT_CALENDAR[row][0]];
    //         const booked = nearestFromDate[CONSTANT_CALENDAR[row][1]];
    //         const remaining = plan - booked;
    //         return { time: row, remaining };
    //       })
    //       ?.filter((row) => {
    //         return row.remaining > 0;
    //       });
    //     const findNearestTime = findFreeSlot[0]?.time;

    //     prepairDate = {
    //       ...prepairDate,
    //       pick_up_date: {
    //         date: `${new Date(onlyDate).getMonth() + 1}.${new Date(
    //           onlyDate
    //         ).getDate()}.${new Date(onlyDate).getFullYear()}`, //11.29.2022
    //         month: new Date(onlyDate).getMonth() + 1,
    //         name: ARRAY_DATE[new Date(onlyDate).getDay()],
    //         disabled: false,
    //         filter: false,
    //         day: new Date(onlyDate).getDate(),
    //         year: new Date(onlyDate).getFullYear(),
    //         time: new Date(onlyDate).getTime(),
    //       },
    //       pick_up_time: findNearestTime,
    //     };
    //     console.log("moreThanTwentFourHour", {
    //       findFreeSlot,
    //       findNearestTime,
    //       prepairDate,
    //       onlyDate,
    //     });
    //   } else {
    //     // ถ้าน้อยกว่า 24 ชั่วโมง ให้เลือก slot ที่เปิดในวันนั้นที่ใกล่ที่สุด

    //     const findFreeSlot = time
    //       .map((row) => {
    //         const plan = nearestFromDate[CONSTANT_CALENDAR[row][0]];
    //         const booked = nearestFromDate[CONSTANT_CALENDAR[row][1]];
    //         const remaining = plan - booked;
    //         return { time: row, remaining, last: checkTime[row] };
    //       })
    //       ?.filter((row) => {
    //         return row.remaining > 0 && row.last > thisHourPushthirtyMinites; // หาว่าในอีก 30 นาที จะเป็นเวลาไหน แล้วเลือกอันที่ใกล่สุด นอกนั้นตัดทิ้ง
    //       });

    //     const findNearestTime = findFreeSlot[0]?.time;

    // prepairDate = {
    //   pick_up_date: {
    //     date: `${new Date(onlyDate).getMonth() + 1}.${new Date(
    //       onlyDate
    //     ).getDate()}.${new Date(onlyDate).getFullYear()}`, //11.29.2022
    //     month: new Date(onlyDate).getMonth() + 1,
    //     name: ARRAY_DATE[new Date(onlyDate).getDay()],
    //     disabled: false,
    //     filter: false,
    //     day: new Date(onlyDate).getDate(),
    //     year: new Date(onlyDate).getFullYear(),
    //     time: new Date(onlyDate).getTime(),
    //   },
    //   pick_up_time: findNearestTime,
    // };
    //     // console.log("lessThanTwentFourHour", {
    //     //   findFreeSlot,
    //     //   findNearestTime,
    //     //   prepairDate,
    //     //   onlyDate,
    //     // });
    //   }
    // }
    // if (nearestToDate) {
    //   //วันที่ส่ง
    //   // const onlyDate = nearestToDate.day.slice(0, 10); //ตัวชัวโมงออกไม่งั้นวันจะเพี้ยน

    //   const onlyDate = DateTime.fromISO(nearestToDate?.day?.slice(0, 10))
    //     .setLocale("th")
    //     .setZone("UTC+7")
    //     .toISO(); // วันที่เป็น 2021-11-29

    //   const moreThanTwentFourHour =
    //     new Date(onlyDate).getTime() - timestampNow() > 86400000;

    //   const nearestFromDatePlusOne = new Date( // ต้อง + 1 เราจะไม่ + หลัง ไม่งั้นพอเอามาเทียบโดนการลบ เวลาจะเพี้ยน
    //     nearestFromDate?.day?.slice(0, 10)
    //   ).setDate(new Date(nearestFromDate?.day?.slice(0, 10)).getDate() + 1);

    //   const isNextDay =
    //     new Date(nearestFromDatePlusOne).getDate() ===
    //     new Date(onlyDate).getDate();

    //   if (moreThanTwentFourHour && !isNextDay) {
    //     // ถ้าไม่ใช่วันถัดไป สามารถเลือก slot ได้ตั้งแต่เวลา 8.00 น. ถึง 20.00 น.
    //     const findFreeSlot = time
    //       .map((row) => {
    //         const plan = nearestToDate[CONSTANT_CALENDAR[row][0]];
    //         const booked = nearestToDate[CONSTANT_CALENDAR[row][1]];
    //         const remaining = plan - booked;
    //         return { time: row, remaining };
    //       })
    //       ?.filter((row) => {
    //         return row.remaining > 0;
    //       });

    //     const findNearestTime = findFreeSlot[0]?.time;

    //     prepairDate = {
    //       ...prepairDate,
    //       return_date: {
    //         date: `${new Date(onlyDate).getMonth() + 1}.${new Date(
    //           onlyDate
    //         ).getDate()}.${new Date(onlyDate).getFullYear()}`, //11.29.2022
    //         month: new Date(onlyDate).getMonth() + 1,
    //         name: ARRAY_DATE[new Date(onlyDate).getDay()],
    //         disabled: false,
    //         filter: false,
    //         day: new Date(onlyDate).getDate(),
    //         year: new Date(onlyDate).getFullYear(),
    //         time: new Date(onlyDate).getTime(),
    //       },
    //       return_time: findNearestTime,
    //     };
    //   } else if (isNextDay) {
    //     // ถ้าเป็นวันถัดไป สามารถเลือก slot ได้หลังจากเวลา รับ แล้วเท่านั้น 24 ชั่วโมง (slot เดียวกันกับเวลารับ)
    //     const findFreeSlot = time
    //       .map((row) => {
    //         const plan = nearestToDate[CONSTANT_CALENDAR[row][0]];
    //         const booked = nearestToDate[CONSTANT_CALENDAR[row][1]];
    //         const remaining = plan - booked;
    //         return { time: row, remaining, last: checkTime[row] };
    //       })
    //       ?.filter((row) => {
    //         return row.remaining > 0 && row.last > thisHourPushthirtyMinites;
    //       });

    //     const findNearestTime = findFreeSlot[0]?.time;

    // prepairDate = {
    //   ...prepairDate,
    //   return_date: {
    //     date: `${new Date(onlyDate).getMonth() + 1}.${new Date(
    //       onlyDate
    //     ).getDate()}.${new Date(onlyDate).getFullYear()}`, //11.29.2022
    //     month: new Date(onlyDate).getMonth() + 1,
    //     name: ARRAY_DATE[new Date(onlyDate).getDay()],
    //     disabled: false,
    //     filter: false,
    //     day: new Date(onlyDate).getDate(),
    //     year: new Date(onlyDate).getFullYear(),
    //     time: new Date(onlyDate).getTime(),
    //   },
    //       return_time: findNearestTime,
    //     };
    //   }
    // }
    // setDateTime(prepairDate);
  }
};

export default BasketAutoSelectDate;
